import { render, staticRenderFns } from "./top-lock.vue?vue&type=template&id=9fc985a2&scoped=true"
import script from "./top-lock.vue?vue&type=script&lang=js"
export * from "./top-lock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fc985a2",
  null
  
)

export default component.exports